import {
  AfterViewInit,
  Component,
  Input,
  ViewChild
} from '@angular/core';
import {
  ControlContainer,
  NgForm,
  NgModel,
  Validators
} from '@angular/forms';

import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-email-control',
  template: require('./email-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class EmailControlComponent extends TextControlComponent implements AfterViewInit {
  // The AngularJS field: only a typed address is checked, so a stored one never blocks saving.
  @Input() isLegacy = false;

  @ViewChild('email') emailModel : NgModel;

  ngAfterViewInit () : void {
    super.ngAfterViewInit();

    if ( this.isLegacy ) {
      this.emailModel.control.addValidators(control => control.dirty ? Validators.email(control) : null);
      this.emailModel.control.updateValueAndValidity();
    }
  }
}
